import {
  Outlet,
  createRootRouteWithContext,
  redirect,
} from "@tanstack/react-router";
import {TanStackRouterDevtools} from "@tanstack/react-router-devtools";
import {QueryClient} from "@tanstack/react-query";
import {ReactQueryDevtools} from "@tanstack/react-query-devtools";
import Config from "@/config";
import useCaptureAffiliateCode from "@/hooks/useCaptureAffiliateCode";

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient;
}>()({
  component: RootComponent,
  beforeLoad: async ({location}) => {
    // if maintenance mode is enabled, redirect to the maintenance page
    if (Config.MAINTENANCE_MODE && location.pathname !== "/maintenance") {
      throw redirect({
        to: "/maintenance",
      });
    }
  },
});

function RootComponent() {
  useCaptureAffiliateCode();

  return (
    <>
      <Outlet />
      {process.env.NODE_ENV === "development" && (
        <>
          <ReactQueryDevtools buttonPosition="bottom-left" />
          <TanStackRouterDevtools position="bottom-left" />
        </>
      )}
    </>
  );
}
